import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default function OrderItem ({ title, children, size }) {
    const wrapClassNames = classNames('mtt-order-item', {
        'mtt-order-item--half': size === 'half',
        'mtt-order-item--third': size === 'third'
    })

    return (
        <div className={wrapClassNames}>
            { title && <div className={'mtt-order-item__title'}>{ title }</div> }
            { children && <div className={'mtt-order-item__text'}>{ children }</div> }
        </div>
    )
}

OrderItem.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
    size: PropTypes.oneOf(['half', 'third'])
}